// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useMantineTheme, useMantineColorScheme } from '@mantine/core';
import { Anchor, Badge, Box, Button, Container, PasswordInput, Stack, Text, TextInput, Title } from '@/components/ui';
import { IconMail, IconLock, IconArrowLeft, IconUsers } from '@tabler/icons-react';
import { FadeIn } from '@/components/animations';
import { SocialFirstCard } from '../components';

export default function ForgotSocialLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const theme = useMantineTheme();
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === 'dark';

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Login:', { email, password });
  };

  const emailForm = (
    <form onSubmit={handleSubmit}>
      <Stack gap="md">
        <TextInput
          label="Email"
          placeholder="you@example.com"
          leftSection={<IconMail size={16} />}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <PasswordInput
          label="Password"
          placeholder="Your password"
          leftSection={<IconLock size={16} />}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <Button type="submit" fullWidth>
          Sign in with Email
        </Button>
      </Stack>
    </form>
  );

  return (
    <Box
      style={{
        minHeight: '100vh',
        backgroundColor: isDark ? theme.colors.dark[8] : theme.colors.gray[0],
        display: 'flex',
        alignItems: 'center',
        padding: '2rem',
      }}
    >
      <Container size="xs" w="100%">
        <FadeIn>
          <Box
            style={{
              backgroundColor: isDark ? theme.colors.dark[7] : 'white',
              borderRadius: theme.radius.lg,
              padding: '2.5rem',
              boxShadow: isDark
                ? '0 4px 24px rgba(0, 0, 0, 0.4)'
                : '0 4px 24px rgba(0, 0, 0, 0.08)',
            }}
          >
            <Stack gap="lg">
              <Button
                component={Link}
                to="/demo/auth-pages/forgot-password"
                variant="subtle"
                size="xs"
                leftSection={<IconArrowLeft size={14} />}
                w="fit-content"
              >
                Back to variants
              </Button>

              <Stack gap="xs" align="center" mb="md">
                <Badge
                  leftSection={<IconUsers size={12} />}
                  variant="gradient"
                  gradient={{ from: 'grape', to: 'pink' }}
                  size="lg"
                >
                  Social Login
                </Badge>
              </Stack>

              <SocialFirstCard
                providers={['google', 'apple', 'github', 'facebook']}
                showEmailOption={true}
                emailFormContent={emailForm}
                title="Enter your email to reset your password"
                subtitle="Choose your preferred method"
              />

              <Text size="sm" ta="center" c="dimmed" mt="md">
                Don't have an account?{' '}
                <Anchor component={Link} to="/demo/auth-pages/register/social-login" fw={500}>
                  Sign up
                </Anchor>
              </Text>
            </Stack>
          </Box>
        </FadeIn>
      </Container>
    </Box>
  );
}
